import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';

import agent from '../api/agent';
import {
  RolePages,
  Roles,
  RoleComponents,
} from './../models/rolesAndPermissions';
import { store } from './store';

export default class RolesAndPermissionsStore {
  rolesRegistry = new Map<string, Roles>();

  selectedRole: Roles | undefined = undefined;
  selectedPage: RolePages | undefined = undefined;
  selectedComponent: RoleComponents | undefined = undefined;
  selectiveRoles: any;

  loadingInitial = false;
  constructor() {
    makeAutoObservable(this);
  }
  private setRoles = (roleDetails: Roles) => {
    this.rolesRegistry.set(roleDetails.id, roleDetails);
  };

  get rolesByName() {
    return Array.from(this.rolesRegistry.values());
  }

  private getRolesById = (id: string) => {
    return this.rolesRegistry.get(id);
  };

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  loadRoles = async () => {
    this.loadingInitial = true;
    try {
      const roleDetails = await agent.Role.listRoles();
      if (store.userStore.user?.customerName === 'LVP CMS - AM') {
        roleDetails.forEach((roles: any) => {
          roles?.pages.forEach((pages: any) => {
            if (pages?.pageName.includes('View Vault')) {
              pages.pageName = pages.pageName.replace(
                'View Vault',
                'View Room',
              );
            }
            if (pages?.pageName.includes('Register Vault')) {
              pages.pageName = pages.pageName.replace(
                'Register Vault',
                'Register Room',
              );
            }
          });
        });
      }
      runInAction(() => {
        roleDetails.forEach((roleDetails) => {
          let acitivitymodes: any = Object.assign([], roleDetails);
          acitivitymodes.pages.forEach((element: any) => {
            element['activeMode'] = 3;
          });
          roleDetails = acitivitymodes;
        });
        this.selectiveRoles = roleDetails;
        roleDetails.forEach((roleDetails) => {
          this.setRoles(roleDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadRolesById = async (id: string) => {
    const Roles = this.getRolesById(id);
    if (Roles) {
      this.selectedRole = Roles;

      return Roles;
    } else {
      this.loadingInitial = true;
      try {
        const Roles = await agent.Role.Roledetails(id);
        this.rolesRegistry.clear();
        runInAction(() => {
          this.setRoles(Roles);
          this.selectedRole = Roles;
        });
        this.setLoadingInitial(false);
        return Roles;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };
  /////////////////////////////////////////////////////////////////////Pages
  loadRolePageById = async (id: string) => {
    this.loadingInitial = true;
    try {
      const Pages = await agent.Pages.pageDetails(id);

      runInAction(() => {
        Pages.components.forEach((element: any) => {
          element['activeMode'] = 3;
        });
        this.selectedPage = Pages;
      });
      this.setLoadingInitial(false);
      return Pages;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  //////////////////////////////////Components
  loadComponentById = async (id: string) => {
    this.loadingInitial = true;
    try {
      const RoleComponent = await agent.Components.componentDetails(id);

      runInAction(() => {
        RoleComponent.features.forEach((element: any) => {
          element['activeMode'] = 3;
        });
        this.selectedComponent = RoleComponent;
      });
      this.setLoadingInitial(false);
      return RoleComponent;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  /////////////Create or Clone New Roles
  createRole = async (Roles: Roles) => {
    try {
      await agent.Role.createRole(Roles);
      runInAction(() => {
        this.rolesRegistry.set(Roles.id, Roles);
      });
      toast.success('Role Create Successfully');
    } catch (error) {
      console.log(error);
      toast.error('Failed to Create');
    }
  };
}
